import { Breadcrumb, Paginator, Table, TitleScreen, Tooltip } from "components/Core"
import ButtonListNavigation from "components/ButtonListNavigation"
import SearchBarFilter from "components/SearchBarFilter"
import { get_data_table_locations } from "helpers/data_tables"
import usePaginationTable from "hooks/usePaginationTable"
import useSearchMiddlewareOSRM from "hooks/useSearchMiddlewareOSRM"
import { useEffect } from "react"
import { LuPencil } from "react-icons/lu"
import useFiltersTable from "hooks/useFiltersTable"
import { parsed_filters_on_search } from "helpers/data_tables"

const ListScreen = () => {
  const { loading_app, data, search_osrm_action } = useSearchMiddlewareOSRM({ entity: "locations" })
  const { current_data, current_page, handle_page_change, handle_per_page, per_page, total_records, total_pages } =
    usePaginationTable({
      data,
    })

  const { filters_table } = useFiltersTable({ table_name: "locations", onFilterApplied: () => handle_page_change(0) })

  useEffect(() => {
    search_osrm_action({ from: per_page * current_page, size: per_page, filters: parsed_filters_on_search(filters_table.state) })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current_page, per_page, filters_table.state])

  const data_table_locations = get_data_table_locations(current_data)

  return (
    <div className="w-full h-full flex flex-col items-center justify-start">
      <Breadcrumb data={[{ name: "Listado de ubicaciones", href: "/locations" }]} />
      <div className="w-full flex flex-col justify-center items-center py-4 px-6">
        <TitleScreen title="listado de ubicaciones" />
        {/* <p>RoutesListScreen</p> */}
      </div>
      <div className="w-full flex flex-col gap-2">
        <div className="w-full flex flex-col lg:flex-row justify-between items-end lg:items-center gap-4 px-6">
          <SearchBarFilter handle_page_change={handle_page_change} />
          <ButtonListNavigation label="Crear Ubicación" route="/locations/new" />
        </div>
        <div className="w-full flex flex-col gap-2 px-6">
          <Paginator
            current_page={current_page}
            handle_page_change={handle_page_change}
            per_page={per_page}
            total_records={total_records}
            total_pages={total_pages}
            handle_per_page={handle_per_page}
          />
          <div className="w-full overflow-x-auto">
            <Table>
              <Table.Head>
                <Table.HeadCell className="!w-5">
                  <></>
                </Table.HeadCell>
                <Table.HeadCell>id</Table.HeadCell>
                <Table.HeadCell>criteria0</Table.HeadCell>
                <Table.HeadCell>criteria1</Table.HeadCell>
                <Table.HeadCell>criteria2</Table.HeadCell>
                <Table.HeadCell>criteria3</Table.HeadCell>
              </Table.Head>
              <Table.Body>
                {!loading_app && data_table_locations?.length ? (
                  data_table_locations.map((location: any, i: number) => (
                    <Table.Row key={i}>
                      <Table.Cell className="flex flex-row items-center justify-end gap-2">
                        <Tooltip content="Editar" align="top">
                          <a href={`/locations/${location?.id}/edit`}>
                            <LuPencil className="pencil_edit opacity-0 text-lg cursor-pointer" />
                          </a>
                        </Tooltip>
                      </Table.Cell>
                      <Table.Cell mainCol>{location?.id}</Table.Cell>
                      <Table.Cell>{location?.criteria0}</Table.Cell>
                      <Table.Cell>{location?.criteria1}</Table.Cell>
                      <Table.Cell>{location?.criteria2}</Table.Cell>
                      <Table.Cell>{location?.criteria3}</Table.Cell>
                    </Table.Row>
                  ))
                ) : (
                  <Table.Row>
                    <Table.Cell>{loading_app ? "Espere..." : "Sin resultados"}</Table.Cell>
                  </Table.Row>
                )}
              </Table.Body>
            </Table>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ListScreen
